
document.addEventListener('click', event => {
  const button = event.target.closest('[data-story-more]');
  if (!button) return;
  const quote = document.getElementById(button.getAttribute('aria-controls'));
  if (!quote) return;
  const expanded = button.getAttribute('aria-expanded') !== 'true';
  button.setAttribute('aria-expanded', String(expanded));
  quote.classList.toggle('is-expanded', expanded);
  button.textContent = expanded ? button.dataset.closeLabel : button.dataset.openLabel;
});


(() => {
  const scriptSelector = 'script[data-bj-instagram-embed]';
  const process = () => window.instgrm?.Embeds?.process?.();
  const loadScript = () => {
    const existing = document.querySelector(scriptSelector);
    if (existing) {
      if (window.instgrm?.Embeds) process();
      else existing.addEventListener('load', process, { once: true });
      return;
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.instagram.com/embed.js';
    script.dataset.bjInstagramEmbed = 'true';
    script.addEventListener('load', process, { once: true });
    document.body.append(script);
  };
  const mount = root => {
    if (!(root instanceof Element) || root.dataset.bjInstagramReady === 'true') return;
    const target = root.querySelector('[data-bj-instagram-profile]');
    const url = target?.dataset.bjInstagramProfile;
    if (!target || !url) return;
    root.dataset.bjInstagramReady = 'true';
    const render = () => {
      if (target.children.length) return;
      const blockquote = document.createElement('blockquote');
      blockquote.className = 'instagram-media';
      blockquote.setAttribute('data-instgrm-permalink', url);
      blockquote.setAttribute('data-instgrm-version', '14');
      target.append(blockquote);
      const placeholder = root.querySelector('[data-bj-instagram-placeholder]');
      const status = root.querySelector('[data-bj-instagram-status]');
      let timer;
      const watch = new MutationObserver(() => {
        const iframe = target.querySelector('iframe');
        if (!iframe) return;
        iframe.title = root.querySelector('.pstr-heading')?.textContent?.trim() || 'Instagram';
        iframe.addEventListener('load', () => {
          if (placeholder) placeholder.hidden = true;
          clearTimeout(timer);
        }, { once: true });
        watch.disconnect();
      });
      watch.observe(target, { childList: true, subtree: true });
      timer = setTimeout(() => {
        if (status) status.textContent = root.dataset.fallbackLabel;
      }, 12000);
      root.bjInstagramCleanup = () => { watch.disconnect(); clearTimeout(timer); };
      loadScript();
    };
    if (!('IntersectionObserver' in window)) {
      render();
      return;
    }
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      observer.disconnect();
      render();
    }, { rootMargin: '600px 0px' });
    observer.observe(root);
  };
  const init = scope => {
    if (scope instanceof Element && scope.matches('[data-bj-instagram-section]')) mount(scope);
    scope.querySelectorAll?.('[data-bj-instagram-section]').forEach(mount);
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-bj-instagram-section]').forEach(root => root.bjInstagramCleanup?.());
  });
})();


(() => {
  const states = new Map();
  const mount = root => {
    const video = root.querySelector('video');
    const button = root.querySelector('[data-bj-video-toggle]');
    if (!video || !button || states.has(root)) return;
    const abort = new AbortController();
    const options = { signal: abort.signal };
    let visible = false;
    let userPaused = false;
    let trying = false;
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    const label = () => {
      const value = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      button.textContent = value;
      button.setAttribute('aria-label', value);
    };
    const play = async () => {
      if (trying || !visible || userPaused || document.hidden) return;
      trying = true;
      try { await video.play(); } catch {}
      finally {
        trying = false;
        if (!visible || userPaused || document.hidden) video.pause();
        label();
      }
    };
    button.addEventListener('click', () => {
      userPaused = !video.paused;
      if (userPaused) video.pause();
      else { visible = true; play(); }
      label();
    }, options);
    video.addEventListener('play', label, options);
    video.addEventListener('pause', label, options);
    video.addEventListener('canplay', play, options);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) video.pause();
      else play();
    }, options);
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible) play();
      else video.pause();
    }, { threshold: .05 }) : null;
    if (observer) observer.observe(video);
    else { visible = true; play(); }
    states.set(root, () => { abort.abort(); observer?.disconnect(); video.pause(); });
    label();
  };
  const init = scope => {
    if (scope.matches?.('.bj-lenticular')) mount(scope);
    scope.querySelectorAll('.bj-lenticular').forEach(mount);
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of states) {
      if (event.target.contains(root)) { cleanup(); states.delete(root); }
    }
  });
})();
